export default __webpack_public_path__ + "static/media/background.1eaf1563.png";